var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-small"},[_vm._v(" "+_vm._s(_vm.$t('note-header.topic', [_vm.content.subject]))+" ")]),_c('discussion-message-card',{attrs:{"compact":"","content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }